import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CLIENT_LOGO_NAMES } from '../../../data/clientLogos';

type Stat = { value: string; label: string };

const logos = [...CLIENT_LOGO_NAMES];

/** Customer names + the site-wide headline numbers, right under the hero. */
export default function ProofBar() {
  const { t, i18n } = useTranslation();

  const stats = useMemo(() => {
    const raw = t('home.proofBar.stats', { returnObjects: true });
    if (!Array.isArray(raw)) return [];
    return raw.filter(
      (s): s is Stat => typeof s === 'object' && s !== null && typeof (s as Stat).value === 'string' && typeof (s as Stat).label === 'string'
    );
  }, [t, i18n.language]);

  return (
    <section className="border-y border-gray-100 bg-white py-7" aria-label={t('home.hero.trustedBy')}>
      <div className="mx-auto max-w-7xl px-6">
        <p className="mb-6 text-center text-xs font-medium uppercase tracking-wider text-gray-500">{t('home.hero.trustedBy')}</p>
        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 z-10 w-20 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute right-0 top-0 bottom-0 z-10 w-20 bg-gradient-to-l from-white to-transparent" />
          <div className="flex animate-slide-logos whitespace-nowrap">
            {[...logos, ...logos].map((name, i) => (
              <div key={i} className="mx-8 flex-shrink-0 select-none text-sm font-bold text-gray-300">
                {name}
              </div>
            ))}
          </div>
        </div>

        {stats.length > 0 && (
          <dl className="mt-7 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col-reverse text-center">
                <dt className="mt-1 text-sm text-gray-500">{s.label}</dt>
                <dd className="text-3xl font-bold tracking-tight text-gray-900">{s.value}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </section>
  );
}
